import $ from 'jquery';
import hoverintent from 'hoverintent';

import Component from '../Component';
import { Breakpoints } from '../constants';

/* Place the sale or sold out badge at the top left of preview thumbnail
* image/s, rather than the top left of the containing <div>.
*/
export default class Badge extends Component {
  constructor(theme, element) {
    super(theme, element);
    this.roots = [];
  }

  add = (element, timeout) => {
    this.roots.push(element);
    this.load(element, timeout);
  }

  onWindowResize = () => {
    const $containers = $(this.roots).find('.grid-view-item .grid-view-item-image');
    const $badges = $containers.find('.badge');
    $badges.css('opacity', 0);
    this.calculateBadgePositions($containers);
    $badges.css('opacity', 1);
  }

  load = (element, timeout = undefined) => {
    const badge = this;
    if(timeout === undefined) {
      timeout = 0;
    }

    const $containers = $(element).find('.grid-view-item .grid-view-item-image');
    this.calculateBadgePositions($containers);

    if(timeout > 0) {
      setTimeout(() => {
        this.calculateBadgePositions($containers);
      }, timeout);
    }

    // On hover, if the 'Enable hover effect' setting is ON we'll need to move
    // the badge on hover as a different image will be shown.
    if ($containers.find('.hidden').length > 0 && this.theme.getWindowWidth() >= Breakpoints.md.min) {
      $containers.each(
        (index, el) => {
          hoverintent(
            el,
            function() {
              if(!$(this).parent('.grid-view-item').hasClass('hovering')) {
                // Fade in second image.
                var self = $(this);
                self.parent('.grid-view-item').addClass('hovering');
                self.find('.hidden').fadeTo(200, 1, function() {
                  badge.calculateHoverBadgePositions($(self));
                });
              }
            },
            function() {
              var self = $(this);
              // Fade out second image.
              $(this).find('.hidden').fadeTo(200, 0, function() {
                badge.calculateBadgePositions($containers);
              });
              self.parent('.grid-view-item').removeClass('hovering');
            }
          ).options({
            sensitivity: 10,
            interval: 25
          });
        },
      );
    }
  }

  calculateHoverBadgePositions = (item) => {
    // If the 'Enable hover effect' setting is ON, also calculate the position
    // of the badge on the second thumbnail.
    if(item.find('.reveal .hidden').length) {
      item.find('.reveal .hidden').css('z-index', 4);
      this.placeBadge(item, true);
    }
  }

  calculateBadgePositions = (container) => {
    container.each((i, el) => {
      this.placeBadge($(el));
      $(el).find('*').stop(true, true);
    });
  }

  placeBadge = (item, hover) => {
    if(hover === undefined) {
      hover = false;
    }

    var badgeDiv = item.parent().find('.badge');
    if(!badgeDiv.length) {
      return;
    }

    // IF - the product grid image aspect ratio setting is selected, ensure the badges are always to the absolute top left of the parent
    if ($('body').hasClass('images-aspect-ratio')) {
      badgeDiv.css('top', '0');
      badgeDiv.css('left', '0');
    }
    // ELSE - we need to work out the correct position for the top left of the image
    else {
      // 1) Get containing .grid-view-item dimensions.
      var containerWidth = item.width();
      var containerHeight = item.height();

      var thisImg;
      // 2) Get thumbnail size.
      if(hover === true) {
        thisImg = item.find('.hidden img');
      }
      else {
        thisImg = item.find('img');
      }

      var actualSize = this.getContainedSize(thisImg.get(0));
      var thisWidth = Math.round(actualSize[0]);
      var thisHeight = Math.round(actualSize[1]);

      // 3) Calculate the left and top difference between container and image.
      var offsetX = (containerWidth - thisWidth) / 2;
      var offsetY = (containerHeight - thisHeight) / 2;

      // Don't allow negative offsets.
      if(offsetX < 1) offsetX = 0;
      if(offsetY < 1) offsetY = 0;

      // 4) Apply those units to the left & top position of the badge.
      badgeDiv.css('top', offsetY + 'px');
      badgeDiv.css('left', offsetX + 'px');
    }
  }

  getContainedSize = (img) => {
    var ratio = img.naturalWidth / img.naturalHeight;
    var width = img.height * ratio;
    var height = img.height;

    if (width > img.width) {
      width = img.width;
      height = img.width / ratio;
    }
    return [width, height];
  }
}
